import { render, staticRenderFns } from "./EventsBiddingManualEntry.vue?vue&type=template&id=201d5c1a&scoped=true"
import script from "./EventsBiddingManualEntry.vue?vue&type=script&lang=js"
export * from "./EventsBiddingManualEntry.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingManualEntry.vue?vue&type=style&index=0&id=201d5c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d5c1a",
  null
  
)

export default component.exports